import axios from 'axios';

const extractJSON = response => response.data;

export default ({
  market, language,
}) => axios({
  // url: `/conversionflow/${market}/${language}/getToken`, // Local debugging
  // eslint-disable-next-line no-underscore-dangle
  url: `${window._env_.PUBLIC_URL || '/'}${market}/${language}/getToken`,
  // url: `${window._env_.PUBLIC_URL || '/api/conversionflow/'}${market}/${language}/getToken`,
  method: 'get',
  headers: {
    version: '1.18.0',
  },
}).then(extractJSON)
  .catch(e => ({ error: e }));
